module.exports = __webpack_public_path__ + "static/media/teacher2.bd985c88.jpg";